/**
 * Os textos montados do painel da ficha da leitura (E139.F3): o nome de cada informação e a fonte
 * escrita como o perito a procura no papel.
 */
import { ptBR } from '@/i18n/pt-BR';
import type { CampoDaFichaData, FonteDoCampoData } from '@/lib/ficha_da_leitura';

export const t = ptBR.fichaDaLeitura;
/** Os textos de "Rever leitura na fonte" (E155.F3). */
export const r = t.releitura;

export function preencher(texto: string, valores: Record<string, string | number>): string {
  return Object.entries(valores).reduce(
    (acumulado, [chave, valor]) => acumulado.replaceAll(`{${chave}}`, String(valor)),
    texto,
  );
}

/** O nome da informação; o código declarado leva o nome da peça. */
export function rotuloDoCampo(campo: CampoDaFichaData): string {
  if (campo.campo === 'codigo_declarado' && campo.referente_nome) {
    return preencher(t.codigoDaPeca, { peca: campo.referente_nome });
  }
  return t.campo[campo.campo];
}

/** "CCB.pdf, página 2" — a página do documento, como o perito o vê na lista. */
export function textoDaFonte(fonte: Pick<FonteDoCampoData, 'documento_nome' | 'pagina'>): string {
  if (fonte.pagina === null)
    return preencher(t.fonteSemPagina, { documento: fonte.documento_nome });
  return preencher(t.fonte, { documento: fonte.documento_nome, pagina: fonte.pagina });
}
